<div class="flex">
    
    <ng-container *ngIf="!hideBreadCrumb">

        <div class="">
            <a rel="follow" href="" class="cursor-pointer">
                صفحه اصلی
            </a>
        </div>
        
        <span class="px-2"> &#62; </span>

        <ng-container *ngIf="!lastIndex">
            <a rel="follow" [routerLink]="url">
                {{nameRoute}}
            </a>
        </ng-container>
        <ng-container *ngIf="lastIndex">
            <p>
                {{nameRoute}}
            </p>
        </ng-container>

        <ng-container *ngIf="!lastIndex">
            <span class="px-2"> &#62; </span>
            <div class="">
                <p>
                    {{pageTitle}}
                </p>
            </div>
        </ng-container>

    </ng-container>

</div>